// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyASX0h7ch-9Ne7GkH9_pq1EWOz0jFPG_Qg",
  authDomain: "mi3-connect.firebaseapp.com",
  projectId: "mi3-connect",
  storageBucket: "mi3-connect.appspot.com",
  messagingSenderId: "197914117133",
  appId: "1:197914117133:web:54eb83bbd3f9475deb8144",
  measurementId: "G-Y01FDME0NP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const functions = getFunctions();
const db = getFirestore(app);

const sendEmail = httpsCallable(functions, "sendEmail");

export {
  sendEmail,
  db
};